export const WORKS_CONSTS = {
    SET_WORKS_DATA:"SET_WORKS_DATA",
    CREATE_WORK_ITEM:"CREATE_WORK_ITEM",
    UPDATE_WORK_ITEM: "UPDATE_WORK_ITEM",
    DELETE_WORK_ITEM: "DELETE_WORK_ITEM",
    UPDATE_WORKS_POSITIONS: "UPDATE_WORKS_POSITIONS",
};
